module.exports = __webpack_public_path__ + "static/media/ETH-USDT.86b806b5.svg";